<template>

    <table class="table border-bottom mt-2" style="margin-bottom: 0px;font-size: .85rem;">
        <tbody>

        <tr class="info-row">
            <td colspan="2" class="editor-content bg-primary text-white"><strong>Block</strong></td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Width</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="column.width" @change="onWidthSelected">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                    <option>5</option>
                    <option>6</option>
                    <option>7</option>
                    <option>8</option>
                    <option>9</option>
                    <option>10</option>
                    <option>12</option>
                </select>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Align</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="column.justify">
                    <option v-for="justifyOption in model.justifyOptions">{{justifyOption}}</option>
                </select>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Align (v)</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="column.align">
                    <option v-for="alignOption in model.alignOptions">{{alignOption}}</option>
                </select>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Direction</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select" v-model="column.direction">
                    <option>row</option>
                    <option>column</option>
                </select>
            </td>
        </tr>

        <tr>
            <td class="editor-content editor-label">Card</td>
            <td class="editor-content">
                <input type="checkbox" id="checkbox" v-model="column.includeCard">
            </td>
        </tr>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Margin</td>
        </tr>

        <margin-selector :spacing="column.margin"></margin-selector>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Padding</td>
        </tr>

        <margin-selector :spacing="column.padding"></margin-selector>


        </tbody>
    </table>
</template>

<script>
    import LayoutFactory from "../../utils/LayoutFactory";
    import LayoutUtil from "../../utils/LayoutUtil";
    import ComponentProperties from "./ComponentProperties.vue";
    import LabelEditor from "./LabelEditor.vue";
    import ContextColorEditor from "./ContextColorEditor.vue";
    import MarginSelector from "./MarginSelector.vue";

    export default {
        name: 'ColumnProperties',
        components: {MarginSelector, ContextColorEditor, LabelEditor, ComponentProperties},
        props: ['layout'],
        data() {
            return {
                model: webase.model,
                factory: new LayoutFactory(),
                layoutUtil: new LayoutUtil()
            }
        },
        computed: {
            column() {
                return this.layout.selectedColumn
            }
        },
        mounted() {
        },
        methods: {

            onWidthSelected() {
                this.layoutUtil.setColumnWidths(this.column, this.layout.selectedRow.columns)
            }
        }
    }
</script>

